import * as React from "react";
import type { SVGProps } from "react";
const SvgHelp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill="#557B97"
      d="m13.07 9.375-.9.92c-.72.72-1.17 1.33-1.17 2.83H9v-.5c0-1.11.45-2.11 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41a2 2 0 1 0-4 0H6a4 4 0 0 1 8 0 3.2 3.2 0 0 1-.93 2.25M11 17.125H9v-2h2zm-1-17a10 10 0 1 0 10 10c0-5.53-4.5-10-10-10"
    />
  </svg>
);
export default SvgHelp;
